import React, { useState } from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import env from '../../env';
import icons from '../../icons';
import Overlay from './Overlay';
import Status from './Status';
import { fetchJSON }    from '@statflo/fetch';
import { getSession }   from '../../services/SessionService';

// const cookies = window.document.cookie.split(/\s*;\s*/);
// const phpCookie = cookies.filter(cookie => cookie.match('PHPSESSID'));
// const phpSessId = (phpCookie.length === 1) ? phpCookie[0].split('=')[1] : null;

const formatDate = (date = null) => {
    if (date) {
        // selected date
        const selected = date ? moment(date) : moment();
        // get todays date
        const today = moment().endOf('day');
        // get date up to a week ago
        const lastWeek = moment().subtract(7, 'days').startOf('day');

        // If the date is today
        if (selected.format('YYYY-MM-DD') === today.format('YYYY-MM-DD')) {
            return selected.format('h:mm A');
        }
        // If the date is within the past week
        if (selected.format('x') >= lastWeek.format('x') && selected.format('x') <= today.format('x')) {
            return selected.format('ddd');
        }
        // if the date is within this year
        if (selected.format('YYYY') === today.format('YYYY')) {
            return selected.format('M/D');
        }
        // if the date is more than a year ago
        if (selected.format('YYYY') < today.format('YYYY')) {
            return selected.format('M/D/YYYY');
        }
    }
};

const SmartListItem = ({ item, history }) => {
    const [open, setOpen] = useState(false);
    const [conversationId, setConversationId] = useState();
    const id = `List-${item.primary_contact_id}`;

    const handleChatStarter = async () => {
        const session = await getSession();
        const requestInit: RequestInit = {
            method: 'POST',
            headers: new Headers({
                'X-Session-ID': session.sid,
                'Content-Type': 'application/json'
            }),
            mode: 'cors',
            cache: 'default',
            body: JSON.stringify({
                ban_id: item.ban_id.toString(),
                contact_id: item.primary_contact_id.toString()
            })
        };

        const response: any = await fetchJSON(`${env.COMMCONTROLLER_HOST}/v1/rest/conversations/`, requestInit);

        if (response && response.details && response.details.conversation) {
            const convId = response.details.conversation.id;
            setConversationId(convId);
            history.push(`/conversation/${convId}?calllist_id=${item.list_id}&list=call&activity_type=${item.activity_type}`);
        }
    };

    const isActiveRoute = () => {
        return (`/conversation/${conversationId}` === history.location.pathname) ? true : false;
    };

    return (
        <div className={(isActiveRoute()) ? 'sl__item__container__link sl__item__container__active' : 'sl__item__container__link'} onClick={handleChatStarter}>
            <div className="sl__item__container" id={id}>
                <div className="sl__item__wrapper">
                    <Overlay visible={open} item={item} />
                    <div className="sl__item__action" onMouseOver={() => setOpen(true)} onMouseOut={() => setOpen(false)} id={`${id}-Info`}>
                        {icons.slInfo}
                    </div>
                    <div className="sl__item__info">
                        <div className="sl__item__row">
                            <div className="sl__item__recipientName">
                                {item.primary_contact_name}
                            </div>
                            <div className="sl__item__timestamp">
                                {formatDate(item.last_activity)}
                            </div>
                        </div>
                        <div className="sl__item__row">
                            <Status label={item.status} type={item.activity_type} expired={item.is_expired}/>
                        </div>
                        <div className="sl__item__row">
                            <div className="sl__item__message">
                                <div className="sl__item__msg_icon">
                                    {icons.slDetails}
                                </div>
                                {item.list_name}
                            </div>
                            {item.unread > 0 &&
                                <div className="sl__item__count">{item.unread}</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(SmartListItem);



// WEBPACK FOOTER //
// ./src/sections/SmartList/SmartListItem.tsx